import React, { useEffect, useState } from 'react';
import Header from './components/Header';
import MobileNav from './components/MobileNav';
import SideBar from './components/SideBar';
import { BiPlus } from 'react-icons/bi';
import { Link, useNavigate } from 'react-router-dom';
import { connect } from 'react-redux';
import { artisanListProducts } from '../../redux/actions/ProductActions';
import { CSVLink } from 'react-csv';
import { FiDownload } from 'react-icons/fi';
import TableFilter from './components/TableFilter';
import Loader from '../../components/Loader';
import Message from '../../components/Message';
import { FiEye, FiTrash2, FiEdit } from 'react-icons/fi';



const ArtisanProductScreen = ({ artisanListProducts, artisanProducts }) => {

    const navigate = useNavigate()

    const { loading, products, error } = artisanProducts;

    const [productData, setProductData] = useState([])

    useEffect(() => {

        artisanListProducts();

    }, [artisanListProducts,])



    const [rowLimit, setRowLimit] = useState(5)
    const [currentPage, setCurrentPage] = useState(1);

    const rowHandler = (e) => {
        const { value } = e.target;
        setRowLimit(value)
    }

    const indexOfLastData = currentPage * rowLimit;
    const indexOfFirstData = indexOfLastData - rowLimit;
    const currentData = products.slice(indexOfFirstData, indexOfLastData)
    const currentProductData = productData.slice(indexOfFirstData, indexOfLastData)


    const searchHandler = (e) => {

        const { value } = e.target;

        if (value) {
            const filter = products.filter((val) => {
                return Object.values(val).join('').toLowerCase().includes(value.toLowerCase())
            })
            setProductData(filter)
        } else {
            setProductData(products)
        }
    }

    const viewProductDetails = (id) => {
        navigate(`/admin/artisan/product/${id}`)
    }

    const headers = [
        { label: "ID", key: "_id" },
        { label: "User ID", key: "user" },
        { label: "Product Name", key: "name" },
        { label: "Product image", key: "image" },
        { label: "Product price", key: "price" },
        // { label: "Brand", key: "brand" },
        { label: "Category", key: "category" },
        { label: "Description", key: "description" },
        { label: "Count In Stock", key: "countInStock" },
        { label: "Rating", key: "rating" },
        { label: "NumReviews", key: "numReviews" },
        { label: "Approved", key: "approved" },
        { label: "CreatedAt", key: "createdAt" },
        { label: "UpdatedAt", key: "updatedAt" },
    ];


    return (
        <div className='bg-gray-100 min-h-screen'>
            <SideBar />
            <MobileNav />
            <Header />
            <div className='md:ml-72 px-4 md:px-2'>
                <div className='my-6 text-3xl font-bold tracking-wide uppercase md:text-center'>
                    artisan Products
                </div>

                <div className='flex justify-between items-center flex-col md:flex-row'>
                    <div className='flex items-center shadow py-2 px-4 sen-font rounded bg-red-300 md:mr-10 mb-5 md:mb-0 w-full md:w-fit'>
                        <FiDownload />
                        <CSVLink headers={headers} data={products} filename="products.csv" className='ml-3'>Export CSV</CSVLink>
                    </div>
                    <input
                        name='search'
                        type='search'
                        onChange={searchHandler}
                        placeholder='search...'
                        className="shadow-sm bg-gray-50 md:w-60 border border-gray-300 text-gray-900 text-sm rounded-lg outline-[#edf2f4] focus:ring-[#83c5be] focus:border-[#83c5be] w-full p-2.5"
                    />
                </div>


                {loading ? <Loader /> : error ? <Message error msg={error} /> : (
                    <>
                        <div className="relative overflow-x-auto mt-10" style={{ height: '410px' }}>
                            <table className="w-full text-sm text-left text-black">
                                <thead className="text-xs text-black mont-font text-white uppercase bg-[#0b2545]">
                                    <tr className='border border-gray-300'>
                                        <th className="px-4 py-3 border border-gray-300">ID</th>
                                        <th className="px-4 py-3 border border-gray-300">IMAGE</th>
                                        <th className="px-4 py-3 border border-gray-300">NAME</th>
                                        <th className="px-4 py-3 border border-gray-300">PRICE</th>
                                        <th className="px-4 py-3 border border-gray-300">CATEGORY</th>
                                        <th className="px-4 py-3 border border-gray-300">CREATED AT</th>
                                        <th className="px-4 py-3 border border-gray-300">APPROVED</th>
                                        <th className="px-4 py-3 border border-gray-300">
                                            <span className="sr-only">ACTION</span>
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {productData.length ? (
                                        <>
                                            {
                                                currentProductData.map((val) => (
                                                    <tr className="bg-white border border-gray-300 transition duration-300 ease-in-out hover:bg-gray-200 sen-font" key={val._id}>
                                                        <td className="p-4 border border-gray-300">{val._id}</td>
                                                        <td className="p-4 border border-gray-300">
                                                            <img src={val.image} className='w-14 h-10' alt={val.name} />
                                                        </td>
                                                        <td className="p-4 border border-gray-300">{val.name}</td>
                                                        <td className="p-4 border border-gray-300">{val.price}</td>
                                                        <td className="p-4 border border-gray-300">{val.category}</td>
                                                        <td className="p-4 border border-gray-300">{val.createdAt.substring(0, 10)}</td>
                                                        <td className="p-4 border border-gray-300">
                                                            {
                                                                val.approved ?
                                                                    <div className=' flex justify-center items-center bg-green-300 p-1 rounded shadow text-black'>
                                                                        success
                                                                    </div>
                                                                    :
                                                                    <div className=' flex justify-center items-center bg-red-400 p-1 rounded shadow text-white'>
                                                                        pending
                                                                    </div>
                                                            }
                                                        </td>
                                                        <td className='p-4 border border-gray-300'>
                                                            <button className='px-3 py-1' onClick={() => viewProductDetails(val._id)}>
                                                                <FiEye className='text-blue-800 text-base' />
                                                            </button>
                                                        </td>
                                                    </tr>
                                                ))
                                            }

                                        </>
                                    ) : (
                                        <>

                                            {
                                                currentData.map((val) => (
                                                    <tr className="bg-white border border-gray-300 transition duration-300 ease-in-out hover:bg-gray-200 sen-font" key={val._id}>
                                                        <td className="p-4 border border-gray-300">{val._id}</td>
                                                        <td className="p-4 border border-gray-300">
                                                            <img src={val.image} className='w-14 h-10' alt={val.name} />
                                                        </td>
                                                        <td className="p-4 border border-gray-300">{val.name}</td>
                                                        <td className="p-4 border border-gray-300">{val.price}</td>
                                                        <td className="p-4 border border-gray-300">{val.category}</td>
                                                        <td className="p-4 border border-gray-300">{val.createdAt.substring(0, 10)}</td>
                                                        <td className="p-4 border border-gray-300">
                                                            {
                                                                val.approved ?
                                                                    <div className=' flex justify-center items-center bg-green-300 p-1 rounded shadow text-black'>
                                                                        success
                                                                    </div>
                                                                    :
                                                                    <div className=' flex justify-center items-center bg-red-400 p-1 rounded shadow text-white'>
                                                                        pending
                                                                    </div>
                                                            }
                                                        </td>
                                                        <td className='p-4 border border-gray-300'>
                                                            <button className='px-3 py-1' onClick={() => viewProductDetails(val._id)}>
                                                                <FiEye className='text-blue-800 text-base' />
                                                            </button>
                                                        </td>
                                                    </tr>
                                                ))
                                            }
                                        </>
                                    )}
                                </tbody>
                            </table>
                        </div>
                        <TableFilter rowHandler={rowHandler} rowLimit={rowLimit} data={products} currentPage={currentPage} setCurrentPage={setCurrentPage} />
                    </>
                )}

            </div>
        </div>
    )
}


const mapStateToProps = (state) => ({
    artisanProducts: state.artisanProducts,
})


export default connect(mapStateToProps, { artisanListProducts })(ArtisanProductScreen);

